<template>
<div>
    <h2 class="mb-4 text-left font-weight-bold">Checklists</h2>
    <b-row class="wiki-main-wrap">
      <div class="tags-main-wrap">
        <section class="widget">
          <div class="text-center">
            <router-link :to="{ path: `/app/checklists/`}">
              <button type="button" class="btn mr-xs btn-success new-page-btn">
                View All Checklists
              </button>
            </router-link>
          </div>
          <div class="text-center">
            <button type="button" class="btn mr-xs btn-success new-page-btn" @click="gotoCreatePage()">
              <i class="fa fa-plus" aria-hidden="true"></i>Create a Checklist
            </button>
          </div>
        </section>
      </div>
      <div class="table-main-wrap">
        <section class="widget">
            <b-row>
                <b-col sm="12">
                <h5 data-v-6d85d69b class="text-tagnew font-semibold mt-3 mb-4">View Checklist :</h5>
                <ErrorDisplay/>
                <b-form class="routine-form" v-if="this.checklist && this.checklist.length > 0">
                    <b-form-group>
                    <b-input-group>
                        <b-input-group-text slot="prepend" class="bg-transparent">
                        <i class="fa fa-list-alt" /> &nbsp; <span>Checklist Name</span>
                        </b-input-group-text>
                        <b-form-input v-model="checklist[0].Name" placeholder="Enter your Checklist name here. i.e Closing Checklist or FrontDesk daily checklist"/>
                    </b-input-group>
                    </b-form-group>
                </b-form>
                <div class="d-flex align-items-center justify-content-between edit-access-mob">
                    <div class="d-flex align-items-center edit-access-mob1">                  
                    </div>                
                </div>
                </b-col>
          </b-row>
           <b-row>
            <b-col sm-12>
               <CustomEditor 
                  v-if="this.editorData" 
                  :editorData="this.editorData" 
                  :editorTools="editorTools"
                  @save="save"                  
                  save-button-id="save-button"
                  >
                </CustomEditor>
            </b-col>
          </b-row>
          <ErrorDisplay/>
        </section>
      </div>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */

import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import CustomEditor from "@/components/Editor/Editor.vue";
import { mapState, mapActions, mapMutations } from 'vuex';
import mixin from '../../mixin.js';
import _ from 'lodash';
import moment from 'moment-timezone';

  export default {
    name: 'ViewChecklist',
    components: { CustomEditor, ErrorDisplay },
    props: ['checklistID'],
    mixins: [mixin],

    created() {
      this.init();
    },

    data() {
      return {
        checklist: {},
        editorTools: {
          checklist: {
            class: "Checklist",
            inlineToolbar: true
          }
        },
      };
  },

  methods: {
      ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
      ...mapActions('checklists', ['getChecklist', 'updateChecklist']),

      async init() {
        this.checklist = await this.getChecklist({checklistID: this.checklistID, siteID: this.siteID});
      },

      onSelect (option) {
        if (option === 'Disable me!') this.isDisabled = true
      },

      onChange (value) {
        this.value = value
        if (value.indexOf('Reset me!') !== -1) this.value = []
      },

      async save(e) {
        //console.log('now updating checklist');
        let payload = {
            ChecklistID: this.checklistID,
            SiteID: this.siteID,
            Name: this.checklist[0].Name,
            Content: JSON.stringify(e)
        };
        //console.log('payload:' + JSON.stringify(payload));
        try {
            await this.updateChecklist(payload);
        } catch(err) {
            this.setErrored(true);
            this.setMessage(`Error while updating checklist: ${err}`);
        }
      },

      onChange: () => {
      },

      gotoCreatePage() {
        this.$router.push('/app/create-checklist');
      },

      successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
      },

    },

    computed: {
      editorData() {
        if(this.checklist && this.checklist.length > 0) {
          return JSON.parse(this.checklist[0].Content);
        }
      },
    }
  };
</script>


<style scoped>

.codex-editor {
  pointer-events: none;
}

.codex-editor .ce-toolbar__plus{ 
  display: none; 
} 

.codex-editor .ce-toolbar{ 
  display:none; 
}

</style>